import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcomethree',
  templateUrl: './welcomethree.component.html',
  styleUrls: ['./welcomethree.component.scss'],
})
export class WelcomethreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
